import {Link} from "react-router-dom";
import {UserCtrl} from "../../controllers/UserCtrl";
import {Language} from "../../controllers/Language";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {cuppa, log} from "../../../cuppa/cuppa";
import {Globals} from "../../controllers/Globals";
import {GetStorage} from "../../../cuppa/reactComponents/GetStorage";
import {Storages} from "../../controllers/Storages";
import {Utils} from "../../controllers/Utils";

export function Menu(props){
	const [organization, setOrganization] = useState();
	const [earlierConversationDate, setEarlierConversationDate] = useState();
	let role = UserCtrl.getRole();

	useEffect(()=>{
		cuppa.on(document.querySelectorAll('.menu a'), 'click', closeDrawer);
	}, []);

	function closeDrawer(){
		if(Globals.menuDrawer) Globals.menuDrawer.close();
	}

	return (
		<div className={`menu ${props.className}`} style={props.style}>
			<GetStorage {...Storages.organization} callback={setOrganization} />
			<GetStorage {...Storages.earlierConversationDate} callback={setEarlierConversationDate} />
			<div style={{textAlign:'center', padding:'2.5rem 1rem 0'}}>
				<Link to={"/"} className={'d-i-children'}>
					<div
						className="bg-contain"
						style={{
							backgroundPosition:'left center',
							height:70,
							backgroundImage:`url(${organization?.logo || require('../../media/images/logo.png')})`,
						}}
					>
					</div>
				</Link>
			</div>
			<img src={require('../../media/images/line.png')} style={{display:'block', width:'100%', height:3, marginTop:10}} alt={"risk-line"} />
			<div style={{flex:1, overflow:'auto'}}>
				<Link to={"/"} className={"btn d-i-children"} >
					<div className={'icon-wrap'}><i className="fa fa-home" aria-hidden="true" /></div>
					<span>{Language.value('Dashboard')}</span>
				</Link>
				<Link to={`/conversations/?&status=ACTIVE&orderBy=last_assessment_date&orderType=DESC${Utils.getDates({noRange:true, urlFriendly:true, from:earlierConversationDate})}`} className={"btn d-i-children"} >
					<div className={'icon-wrap'}><i className="fa fa-comments" aria-hidden="true" /></div>
					<span>{Language.value('Active Cases')}</span>
				</Link>
				{[1].indexOf(parseInt(role?.id)) != -1 && Utils.showMenuAccordingEmail() &&
					<Link to={"/questions/?&target=CONVERSATION"} className={"btn d-none d-i-children"} >
						<div className={'icon-wrap'}><i className="fas fa-question-circle"></i></div>
						<span>{Language.value('Questions')}</span>
					</Link>
				}
				{[1].indexOf(parseInt(role?.id)) != -1 && Utils.showMenuAccordingEmail() &&
					<Link to={"/organizations/?&status=ACTIVE"} className={"btn d-i-children"} >
						<div className={'icon-wrap'}>
							<i className="far fa-sitemap"></i>
						</div>
						<span>{Language.value('Communities')}</span>
					</Link>
				}
				{[1,3].indexOf(parseInt(role?.id)) != -1 &&
					<Link to={"/users/?&organizationStatus=ACTIVE"} className={"btn d-i-children"} >
						<div className={'icon-wrap'}><i className="fa fa-users" aria-hidden="true"/></div>
						<span>{Language.value('Users')}</span>
					</Link>
				}
			</div>
			<div>
				<Link to={"/"} onClick={UserCtrl.logOut} className={"btn d-i-children"} >
					<div className={'icon-wrap'}><i className="fa fa-sign-out" aria-hidden="true" /></div>
					<span>{Language.value('Log out')}</span>
				</Link>
			</div>
		</div>
	)
}

Menu.propTypes = {style:PropTypes.object, className:PropTypes.string};
Menu.defaultProps = {style:null, className:""}
